import { combineReducers } from 'redux';

import apiError from './apiError';
import ids from './ids';
import isLoading from './isLoading';
import isVisible from './isVisible';

export default combineReducers({
  ids,
  apiError,
  isLoading,
  isVisible,
});
